import React, { useState, useEffect } from "react";
import useStorageState from "@/hooks/useStorageState";

import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { IVRMCustomerDetail, IVRMCustomerSearchFields, customerService } from "./baseCustomerService";
import { globalPrompt } from "@/components/message";
import { convertRes2Blob } from "@/utils/exportFile";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums"
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
//设置客户和用户的分支
let IsystemCode: any = {
    "TEST": "vrm-sa",
    "TESTNGA": "vrm-nga",
    "PROD": "vrm-sa",
    "PRODNGA": "vrm-nga"
}
const REACT_APP_ENV = process.env.REACT_APP_ENV as string
let mianCode = IsystemCode[REACT_APP_ENV]
export const useCustomerModel = createModel(function () {
    const { user, setCustomerData, setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeName } = useDictModel();
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IVRMCustomerDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IVRMCustomerSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格选择的id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<IVRMCustomerDetail>();
    // const [CustomerData,setCustomerData,clearCustomerData] = useStorageState<IVRMCustomerDetail[]>("customerList", [])

    //返回客户列表韦options的格式
    const transOptions = async (list: any[]) => {
        return list.map(item => ({ label: item.name, value: item.code }))
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IVRMCustomerSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await customerService.page(searchParams);
        const { records, ...pg } = retData;
        await setPgCfg(transPgToPagination(pg));
        await setDataSource(records);
        await loadCustomerAllData();
    }
    //所有列表查询
    const loadCustomerAllData = async () => {
        const params = {
            pageSize: 1000,
            pageNum: 1
        }
        let { retData } = await customerService.page(params);
        const { records, ...pg } = retData;
        console.log(records)
        setCustomerData([...records])
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IVRMCustomerSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);
    /** 
     * 表单详情
     */

    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<object>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<object>({});
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal({});
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({});
    }
    //获取一条详情数据 Api
    const getCustomerOne = async (id: string) => {
        let { retData } = await customerService.one(id);
        retData && setEditFormVal(retData);
    }

    //表单新增 Api
    const insertCustomer = async (data: IVRMCustomerDetail) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp: 'vrm-nga-s',
            branch: 'vrm-nga-s',
            enable: data.enable ? 1 : 0,
            createUser: user.username,
            categoryName: getTreeNodeName(data.categoryCode as string)

        }
        let { retData } = await customerService.insert(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "客户新增成功", type: "success" })
            // : globalPrompt("message", { text: "客户新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully added"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully added"], type: "error" });
        return retData;
    }

    //表单编辑 Api
    const editCustomer = async (data: IVRMCustomerDetail) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp:  'vrm-nga-s',
            branch:  'vrm-nga-s',
            enable: data.enable ? 1 : 0,
            updateUser: user.username,
            categoryName: getTreeNodeName(data.categoryCode as string)
        }
        let { retData } = await customerService.update(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "客户编辑成功", type: "success" })
            // : globalPrompt("message", { text: "客户编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    //客户禁用开启
    const onDisabled = async (id: string, checked: boolean) => {
        let { retData } = await customerService.disable({ id, enable: checked ? 1 : 0 })
        retData ?
            // loadData() && globalPrompt("message", { text: "客户编辑成功", type: "success" })
            // : globalPrompt("message", { text: "客户编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    //导入
    const importCustomer = async (file: { file: File }) => {
        let { retData } = await customerService.import(file);
        retData ?
            // loadData() && globalPrompt("message", { text: "导入成功", type: "success" })
            // : globalPrompt("message", { text: "导入失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully imported"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully imported"], type: "error" });
        return retData;
    }

    //导出
    const exportCustomer = async (searchValue: IVRMCustomerSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let result = await customerService.export(searchParams);
        convertRes2Blob(result);
    }

    //客户转客户
    const transferCustomer = async (id: string) => {
        let { retData } = await customerService.transfer(id);
        retData ?
            loadData() && globalPrompt("message", { text: "客户转供应商成功", type: "success" })
            : globalPrompt("message", { text: "客户转供应商失败", type: "error" });
        return retData;
    }

    //下载模板
    const downloadTpl = async () => {
        let result = await customerService.downloadTpl();
        convertRes2Blob(result);
        // let { retData } = await customerService.downloadTpl();
        // retData ?
        //     globalPrompt("message", { text: "下载模板成功", type: "success" })
        //     : globalPrompt("message", { text: "下载模板失败", type: "error" });
        // return retData;
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        editFormVal,
        addFormVal,
        selectedData,
        // CustomerData,
        /***method***/
        updateAddFormVal,
        updateEditFormVal,
        insertCustomer,
        editCustomer,
        getCustomerOne,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        importCustomer,
        exportCustomer,
        transferCustomer,
        downloadTpl,
        setAddFormVal,
        onDisabled,
        setSelectedData,
        loadCustomerAllData,
        // setCustomerData,
        // clearCustomerData,
        transOptions
    }
});